import './BeerPriceField.scss';
import {faTrash} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Button from 'components/Button/Button';

import CurrencySelect from './CurrencySelect/CurrencySelect';

interface IBeerPriceFieldProps {
  id: number;
  amount: string;
  price: string;
  currency: string;
  handleUpdatePrice: ({id, field, value}: {id: number; field: string; value: string}) => void;
  handleRemovePrice: (id: number) => void;
}

const BeerPriceField = ({amount, price, currency, handleUpdatePrice, id, handleRemovePrice}: IBeerPriceFieldProps) => {
  const areValuesEntered = amount && price;

  return (
    <div className={`beer-price-field ${areValuesEntered ? 'beer-price-field--values-entered' : ''}`}>
      <div className="beer-price-field__field">
        <input
          type="number"
          value={amount}
          onChange={(e) => handleUpdatePrice({id, field: 'amount', value: e.target.value})}
          className="beer-price-field__amount"
          placeholder="l"
          name="amount"
        />
        <input
          type="number"
          value={price}
          onChange={(e) => handleUpdatePrice({id, field: 'price', value: e.target.value})}
          className="beer-price-field__price"
          placeholder="0.00"
          name="price"
        />
        <CurrencySelect currency={currency} handleUpdatePrice={handleUpdatePrice} id={id} />
      </div>
      <Button
        variant="empty"
        className="beer-price-field__delete"
        title="remove price"
        onClick={() => handleRemovePrice(id)}
        disabled={!areValuesEntered}
      >
        <FontAwesomeIcon icon={faTrash} color={`${areValuesEntered ? '#FFBF17' : '#828282'}`} />
      </Button>
    </div>
  );
};

export default BeerPriceField;
